import DashedCircleCartIcon from '@assets/icons/dashed-circle-cart.svg';
import i18n from '@/utils/i18n';
import {
  Button,
  ButtonSize,
  ButtonVariant,
} from '@/experiences/sales-portal/components/button';
import { createStyles } from '@/contexts/theme-context';
import { EmptyState } from '@experiences/components/empty-state';

interface OrderEntryCheckoutSummaryEmptyStateProps {
  onPress: () => void;
}

export const OrderEntryCheckoutSummaryEmptyState: React.FC<
  OrderEntryCheckoutSummaryEmptyStateProps
> = ({ onPress }) => {
  const [styles, theme] = useStyles();

  return (
    <EmptyState
      bottomElement={
        <Button
          accessibilityLabel={i18n.t(
            'sales_portal.order_entry.checkout_panel.summary.empty.cta',
          )}
          onPress={onPress}
          size={ButtonSize.Small}
          style={styles.button}
          variant={ButtonVariant.Secondary}
        >
          {i18n.t('sales_portal.order_entry.checkout_panel.summary.empty.cta')}
        </Button>
      }
      description={i18n.t(
        'sales_portal.order_entry.checkout_panel.summary.empty.description',
      )}
      iconElement={
        <DashedCircleCartIcon stroke={theme.sk.color.icon.primary} />
      }
      title={i18n.t(
        'sales_portal.order_entry.checkout_panel.summary.empty.title',
      )}
    />
  );
};

const useStyles = createStyles((theme) => ({
  button: {
    paddingHorizontal: theme.sk.spacing.spaceMedium,
  },
}));
